import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.blue.default};
  padding: 64px;
  border-radius: 8px;
  display: flex;
  gap: 48px;
  justify-content: space-between;
  overflow: hidden;

  > div:first-of-type {
    width: 45%;
  }

  > div:nth-of-type(2) {
    width: 55%;
  }

  ${mediaQuery(BREAKPOINTS.tablet)} {
    padding: 32px;
    flex-direction: column;
    gap: 0;

    > div:first-of-type,
    > div:nth-of-type(2) {
      width: 100%;
    }
  }
`;

export const DogsImage = styled.div`
  position: absolute;
  left: 100px;
  bottom: -14px;
  width: 255px !important;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    display: none;
  }
`;

export const PawsImage = styled.div`
  position: absolute;
  right: 4px;
  top: 4px;
  width: 40px !important;
`;

export const AccordionContent = styled.p`
  margin: 0;
  white-space: pre-line;
  padding: 20px;
  background: ${(props) => props.theme.color.light.default};
`;
